export default __webpack_public_path__ + "static/phone-30fff072ff352dca82287585f2a2771e.png";